class AddonModel {
  constructor({ id = "", key = "", name = "", price = 0, unitOfItem = "", unitOfTime = "", isActive = false, value = 0 }) {
    this._id = id;
    this._key = key;
    this._name = name;
    this._price = price;
    this._unitOfItem = unitOfItem;
    this._unitOfTime = unitOfTime;
    this._isActive = isActive;
    this._value = value;
  }
  get id() {
    return this._id;
  }

  get key() {
    return this._key;
  }

  get name() {
    return this._name;
  }

  get price() {
    return this._price;
  }

  get unitOfItem() {
    return this._unitOfItem;
  }

  get unitOfTime() {
    return this._unitOfTime;
  }

  get isActive() {
    return this._isActive;
  }

  get value() {
    return this._value;
  }

  toJSON() {
    return {
      id: this._id,
      key: this._key,
      name: this._name,
      price: this._price,
      unitOfItem: this._unitOfItem,
      unitOfTime: this._unitOfTime,
      isActive: this._isActive,
      value: this._value,
    };
  }
}

export default AddonModel;
